"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkIcon = exports.EditLink = exports.FlexCard = exports.Editable = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Editable = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n"])));
exports.FlexCard = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n"], ["\n  height: 100%;\n"])));
exports.EditLink = styled_components_1.default.div(function (_a) {
    var space = _a.theme.space;
    return "\n    padding-left: ".concat(space[2], ";\n    flex: 1;\n    text-align: right;\n    white-space: nowrap;\n  ");
});
// Use margin to avoid underline.
exports.LinkIcon = styled_components_1.default.svg(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 0.3em;\n"], ["\n  margin-left: 0.3em;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
